import {inject, injectable} from 'inversify';

import {FetchUnboundGoalsQuery} from '../../ports/Goal/FetchUnboundGoals/FetchUnboundGoals.query';

@injectable()
export class FetchProgramGoalsUseCase {
  constructor(
    @inject(FetchUnboundGoalsQuery)
    private readonly query: FetchUnboundGoalsQuery,
  ) {}

  async exec({
    programId,
  }: FetchProgramGoalsUseCase.Props): Promise<FetchProgramGoalsUseCase.Response> {
    return this.query.exec({
      programId,
    });
  }
}

export namespace FetchProgramGoalsUseCase {
  export type Props = {
    programId: string;
  };
  export type Response = FetchUnboundGoalsQuery.Response;
}
